import React, { useState, useEffect } from "react";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import {
  DeleteServiceCaller,
  GetServiceCaller,
} from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import { Modal, Button, Form } from "react-bootstrap";
import HTMLComponent from "../../../../components/HtmlComponent";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import DeleteModal from "../../../../components/DeletePopUpComponent";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { useDispatch } from "react-redux";

const RoleList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Roles"));
  }, []);
  const [currentOpportunityList, setCurrentOpportunityList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(true);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [role_id, setRoleToDelete] = useState(0);
  const [submitted, setSubmit] = useState(false);

  const columns = {
    Code: { text: "Code", align: "left", visible: true },
    Name: { text: "Name", align: "left", visible: true },
    Active: { text: "Active", align: "center", visible: true },
  };

  const handleGetData = () => {
    fetchRoles();
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}role`);
      if (response.status === 200) {
        const cleanedData = response.data.roles;
        console.log("cleanedData", cleanedData);

        setCurrentOpportunityList(cleanedData);
        setLoading(false);
      } else {
        console.error(
          "Failed to fetch partnerMaster. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching PartnerMaster:", error);
    }
  };
  const handleEdit = (item) => {
    // console.log(`here is item`);
    // console.log(item);
    navigate("/roles/edit/" + item.ID);
  };
  const handleAdd = () => {
    navigate("/roles/add");
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  console.log("selectedDeleteItem", selectedDeleteItem);

  const handleDelete = (item) => {
    setSelectedDeleteItem(item);
    setShowDeleteModal(true);
  };
  const handleDeleteClose = () => {
    setShowDeleteModal(false);
    setSelectedDeleteItem(null);
  };

  const handleModalDelete = () => {
    if (selectedDeleteItem) {
      {
        handleDeleteLine(selectedDeleteItem.ID);
      }
      setShowDeleteModal(false);
      setSelectedDeleteItem(null);
    }
  };

  const handleDeleteLine = async (role_id) => {
    if (role_id) {
      // Checks if PocID is truthy (not null, undefined, or empty)
      try {
        const response = await DeleteServiceCaller(
          `${API_URL}role/${role_id}`,
          {},
          "delete"
        );
        console.log("response", response);

        if (response?.status === 200) {
          toast.success("Data Deleted successfully");
          fetchRoles();
        }
      } catch (error) {
        console.error("There was an error deleting the Row!", error);
      }
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="crad rounded bg-white" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              isAddNewButtonRequired={true}
              data={currentOpportunityList}
              isActionRequired={true}
              columns={columns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              showIcon2={false}
              showIcon3={true}
              isSorting={true}
              handleIcon1={handleEdit}
              handleIcon2={handleDelete}
              handleIcon3={handleEdit}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
                Icon1Text: "Edit",
                Icon2: <i className="bi bi-trash3 icons"></i>,
                Icon2Text: "Delete",
              }}
              isFilteredRequired={false}
              handleAddNew={handleAdd}
              isAddNewBtnRequired={true}
            />
          </div>
        </div>
        <DeleteModal
          show={showDeleteModal}
          onClose={handleDeleteClose}
          onConfirm={handleModalDelete}
          message="Are you sure you want to delete this item?"
        />
      </div>
    </>
  );
};

export default RoleList;
